const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`, `3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`, 1, 55), undefined, true, false, 1));
            }

            getTemplateName() {
                return `3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`;
            }

            getSourceContext() {
                return new this.Source(``, `3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`, ``);
            }
        }],
        [55, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`, 1);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if ((context.has(`show_heading`) ? context.get(`show_heading`) : null)) {
                    this.echo(`Lorem ipsum dolor sit amet`);
                }
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if ((context.has(`show_cover`) ? context.get(`show_cover`) : null)) {
                    this.echo(`<img src="https://placeimg.com/800/450/animals" alt="">`);
                }
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if ((context.has(`show_content`) ? context.get(`show_content`) : null)) {
                    this.echo(`<p>Consectetur adipiscing elit. Fusce tempor ut ex nec scelerisque. Quisque dui tortor, tempus et tempor in, rhoncus eu massa. Vestibulum dolor erat, vestibulum eget velit eu, dignissim hendrerit tortor.</p>`);
                }
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if ((context.has(`show_footer`) ? context.get(`show_footer`) : null)) {
                    this.echo(`<p>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(19, this.source)(...[this.env, `now`, `M j, Y`]), `html`, null, true]));
                    this.echo(`</p>`);
                }
            }

            getTemplateName() {
                return `3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686');

let template = env.loadTemplate('3c842705765b7f8f15d26a5b6271d3ded771a86a3f4e15e57f2150d42cade686');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/card/demo/single.twig", args: context }
     );
     return rendered;;
};